import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { MapPanel } from './MapPanel';

export class MapPopup extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <div>
                {
                    <Modal isOpen={true}>
                        <ModalHeader>
                            {this.props.headerText}
                        </ModalHeader>
                        <ModalBody>
                            <MapPanel postcode={this.props.postcode} />
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                color="secondary"
                                onClick={this.props.onClose}>
                                Cancel
                                </Button>
                        </ModalFooter>
                    </Modal>
                }
            </div>
        );
    }
}